import React, { useState } from 'react';
import { Send, CheckCircle, AlertCircle } from 'lucide-react';

const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    negocio: '',
    correo: '',
    mensaje: ''
  });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');

    try {
      const response = await fetch('https://n8n.riosia25.cloud/webhook/formulario', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus('success');
        setFormData({ nombre: '', negocio: '', correo: '', mensaje: '' });
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setStatus('error');
    }
  };

  return (
    <div className="w-full max-w-lg mx-auto bg-mira-surface border border-mira-border rounded-2xl p-8 shadow-[0_0_40px_rgba(0,0,0,0.3)]">
      <h3 className="text-3xl font-extrabold mb-8 text-white text-center tracking-tight drop-shadow-[0_0_10px_rgba(26,140,255,0.2)]">Inicia tu <span className="text-mira-accent">Transformación</span></h3>
      
      {status === 'success' ? (
        <div className="text-center py-12 animate-fade-in">
          <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="w-8 h-8 text-green-500" />
          </div>
          <h4 className="text-xl font-bold text-white mb-2">¡Mensaje Enviado!</h4>
          <p className="text-gray-400">Gracias por contactarnos. Nuestro equipo analizará tu caso y te responderá en breve.</p>
          <button 
            onClick={() => setStatus('idle')}
            className="mt-6 text-mira-accent hover:text-white text-sm font-medium transition-colors"
          >
            Enviar otro mensaje
          </button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label htmlFor="nombre" className="block text-sm font-bold text-gray-300 mb-1 ml-1">Nombre Completo</label>
            <input
              type="text"
              id="nombre"
              name="nombre"
              required
              value={formData.nombre}
              onChange={handleChange}
              className="w-full px-4 py-3 bg-mira-bg border border-mira-border rounded-lg text-white focus:outline-none focus:border-mira-accent focus:ring-1 focus:ring-mira-accent transition-all placeholder-gray-600 shadow-inner"
              placeholder="Juan Pérez"
            />
          </div>

          <div>
            <label htmlFor="negocio" className="block text-sm font-bold text-gray-300 mb-1 ml-1">Nombre del Negocio</label>
            <input
              type="text"
              id="negocio"
              name="negocio"
              required
              value={formData.negocio}
              onChange={handleChange}
              className="w-full px-4 py-3 bg-mira-bg border border-mira-border rounded-lg text-white focus:outline-none focus:border-mira-accent focus:ring-1 focus:ring-mira-accent transition-all placeholder-gray-600 shadow-inner"
              placeholder="Clínica Dental Elite"
            />
          </div>

          <div>
            <label htmlFor="correo" className="block text-sm font-bold text-gray-300 mb-1 ml-1">Correo Electrónico</label>
            <input
              type="email"
              id="correo"
              name="correo"
              required
              value={formData.correo}
              onChange={handleChange}
              className="w-full px-4 py-3 bg-mira-bg border border-mira-border rounded-lg text-white focus:outline-none focus:border-mira-accent focus:ring-1 focus:ring-mira-accent transition-all placeholder-gray-600 shadow-inner"
              placeholder="juan@ejemplo.com"
            />
          </div>

          <div>
            <label htmlFor="mensaje" className="block text-sm font-bold text-gray-300 mb-1 ml-1">¿Qué necesitas automatizar?</label>
            <textarea
              id="mensaje"
              name="mensaje"
              rows={4}
              required
              value={formData.mensaje}
              onChange={handleChange}
              className="w-full px-4 py-3 bg-mira-bg border border-mira-border rounded-lg text-white focus:outline-none focus:border-mira-accent focus:ring-1 focus:ring-mira-accent transition-all placeholder-gray-600 resize-none shadow-inner"
              placeholder="Me gustaría un chatbot para agendar citas..."
            ></textarea>
          </div>

          {status === 'error' && (
             <div className="flex items-center gap-2 text-red-400 text-sm bg-red-400/10 p-3 rounded-lg border border-red-400/20">
               <AlertCircle className="w-4 h-4" />
               Hubo un error al enviar. Por favor intenta de nuevo.
             </div>
          )}

          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full py-4 bg-mira-accent text-mira-bg font-bold rounded-lg hover:bg-blue-400 transition-all shadow-[0_0_20px_rgba(26,140,255,0.3)] hover:shadow-[0_0_30px_rgba(26,140,255,0.5)] flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed text-lg"
          >
            {status === 'loading' ? (
              <>
                <div className="w-5 h-5 border-2 border-mira-bg border-t-transparent rounded-full animate-spin"></div>
                Enviando...
              </>
            ) : (
              <>
                Enviar Solicitud <Send className="w-5 h-5" />
              </>
            )}
          </button>
        </form>
      )}
    </div>
  );
};

export default ContactForm;